
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/link-demo/accounts",
      function () {
        return require("private-next-pages/link-demo/accounts.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/link-demo/accounts"])
      });
    }
  